import {
  AdminUserLoginParams,
  AdminUserLoginResponse,
  AdminUserLogoutResponse,
  AdminUserSelfUpdateParams,
  AdminUserSelfUpdateResponse,
} from "src/types/account";
import axios, { endpoints } from "src/utils/axios";

export const authApi = {
  login: async (
    params: AdminUserLoginParams
  ): Promise<AdminUserLoginResponse> => {
    const response = await axios.post(endpoints.auth.login, params);
    return response.data;
  },

  logout: async (): Promise<AdminUserLogoutResponse> => {
    const response = await axios.get(endpoints.auth.logout);
    return response.data;
  },

  changePassword: async (data: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }): Promise<AdminUserSelfUpdateResponse> => {
    const updateParams: AdminUserSelfUpdateParams = {
      current_password: data.currentPassword,
      password: data.newPassword,
      confirm_password: data.confirmPassword,
    };
    const response = await axios.patch(
      endpoints.auth.changePassword,
      updateParams
    );
    return response.data;
  },
};
